type ToPartitionRadiusArgs = {
  diameter: number;
  /** The depth of the whole tree, in rings below the root. */
  totalDepth: number;
  /** How many of those rings the depth setting leaves on screen. */
  drawnDepth: number;
};

/**
 * The radius to lay `d3.partition` out in so the rings that are drawn reach the edge of the pane
 * and no further.
 *
 * `partition` spreads its radius across every level it is given a node for, and that includes
 * the root — `totalDepth + 1` bands, of which the view draws `drawnDepth` starting at the
 * second. Scaling by the ratio of the depths alone ignores the band the undrawn root holds, and
 * overshoots the pane by more the shallower the depth setting is.
 */
export const toPartitionRadius = ({
  diameter,
  totalDepth,
  drawnDepth,
}: ToPartitionRadiusArgs): number =>
  (diameter / 2) * ((totalDepth + 1) / (drawnDepth + 1));
